import { useAppSelector } from "../../lib/redux/hooks"
import { Layout } from "../../ui/layout"
import Button from "../../ui/molecules/button"
import { Banner } from "../../ui/organisms/banner"
import { MenuItems } from "../../ui/organisms/navbar/dto"
import { NotifyListBio } from "./bioList"
import { NotifyGlobalGapList } from "./globalGapList"
import { NotifyProdIntegrataList } from "./prodIntegrataList"

export function Notify() {
    const sessionState = useAppSelector(state => state.session)

    const selectedList = () => {
        switch (sessionState.selected.customerNorm) {
            case 'NORMA_BIO':
                return <NotifyListBio />

            case 'GLOBAL_GAP':
                return <NotifyGlobalGapList />

            case 'PRODUZIONE_INTEGRATA':
                return <NotifyProdIntegrataList />
        }
    }

    if (sessionState.selected.customerId) {
        return (
            <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Notifiche']}
                noPaddingLat
                headerLabel="Notifiche"
                customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
                customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
            >
                {selectedList()}
            </Layout>
        )
    }

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Notifiche']}
            noPaddingLat
            headerLabel={"Notifiche"}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}